import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Header from '../component/Header'
import Footer from '../component/Footer'
import HomeRealEstateAgentForm from '../component/HomeRealEstateAgentForm'
import ExploreResultLocations from '../component/ExploreResultLocations'
import RecommendedYou from '../component/RecommendedYou'
import ProductCommercialView from '../component/ProductCommercialView'
import ProductCommercialDetails from '../component/ProductCommercialDetails'
import { GET_PROPERTY_BY_SLUG } from '../api/constants'
import { useProperty } from "../hooks/useProperty";

function CommercialDetails() {
  const { property, loading } = useProperty();


   if (loading) {
    return (
      <>
        <style>{`
          .property-loading {
            padding: 30px;
          }

          .loading-gallery {
            width: 100%;
            height: 420px;
            border-radius: 20px;
            margin-bottom: 24px;
          }

          .loading-content {
            display: flex;
            flex-direction: column;
            gap: 16px;
          }

          .loading-title {
            height: 40px;
            width: 60%;
            border-radius: 10px;
          }

          .loading-subtitle {
            height: 24px;
            width: 40%;
            border-radius: 10px;
          }

          .loading-stats {
            display: flex;
            gap: 12px;
          }

          .loading-stat {
            height: 50px;
            width: 120px;
            border-radius: 12px;
          }

          .loading-description {
            height: 18px;
            width: 100%;
            border-radius: 8px;
          }

          .loading-description.short {
            width: 70%;
          }

          .shimmer {
            position: relative;
            overflow: hidden;
            background: #e5e7eb;
          }

          .shimmer::after {
            content: "";
            position: absolute;
            top: 0;
            left: -150%;
            width: 150%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(255,255,255,0.6),
              transparent
            );
            animation: shimmer 1.3s infinite;
          }

          @keyframes shimmer {
            100% {
              left: 150%;
            }
          }
        `}</style>

        <div className="main product-details">
          <Header />

          <div className="property-loading">
            <div className="loading-gallery shimmer"></div>

            <div className="loading-content">
              <div className="loading-title shimmer"></div>
              <div className="loading-subtitle shimmer"></div>

              <div className="loading-stats">
                <div className="loading-stat shimmer"></div>
                <div className="loading-stat shimmer"></div>
                <div className="loading-stat shimmer"></div>
              </div>

              <div className="loading-description shimmer"></div>
              <div className="loading-description short shimmer"></div>
            </div>
          </div>

          <Footer />
        </div>
      </>
    );
  }

  if (!property) {
    return (
      <>
        <style>{`
          .property-not-found {
          min-height: 60vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
        }

        .not-found-card {
          max-width: 500px;
          width: 100%;
          background: #fff;
          border-radius: 24px;
          padding: 40px;
          text-align: center;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
        }

        .not-found-card h2 {
          margin-bottom: 16px;
          font-size: 32px;
          font-weight: 700;
        }

        .not-found-card p {
          color: #666;
          margin-bottom: 28px;
          line-height: 1.6;
        }

        .not-found-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .browse-btn,
        .back-btn {
          border: none;
          padding: 14px 22px;
          border-radius: 12px;
          font-weight: 600;
          cursor: pointer;
          text-decoration: none;
        }

        .browse-btn {
          background: #111827;
          color: white;
        }

        .back-btn {
          background: #f3f4f6;
        }
        `}</style>
        <div className="main product-details">
          <Header />

          <div className="property-not-found">
            <div className="not-found-card">
              <h2>Property not found</h2>

              <p>
                The property may have been removed, expired, or the link is
                invalid.
              </p>

              <div className="not-found-actions">
                <a href="/commercial" className="browse-btn">
                  Browse Properties
                </a>

                <button
                  className="back-btn"
                  onClick={() => window.history.back()}
                >
                  Go Back
                </button>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </>
    );
  }
  return (
    <>
      <div className='main product-details'>
        <Header />
        <ProductCommercialView property={property} />
        <ProductCommercialDetails property={property} />
        <HomeRealEstateAgentForm property={property} />
        <RecommendedYou />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  )
}
export default CommercialDetails


